import { render, staticRenderFns } from "./dashboardMobile.vue?vue&type=template&id=53fec3a2&scoped=true&"
import script from "./dashboardMobile.vue?vue&type=script&lang=js&"
export * from "./dashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./dashboardMobile.vue?vue&type=style&index=0&id=53fec3a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fec3a2",
  null
  
)

export default component.exports